import { PropertyFilterType } from 'components/molecules/ProductFilter/configuration';
import { IFiltersSelection } from 'components/molecules/ProductFilter/store/reducer';
import _ from 'lodash';

export function objectWithoutProperties(obj: any, keys: Array<string>) {
  let target: any = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

export function isObjectNullish(object: any = {}): boolean {
  return Object.values(object).every((value) => {
    if (
      (!value && value !== 0) ||
      (Array.isArray(value) && value.length === 0)
    ) {
      return true;
    }
    return false;
  });
}

export function renderDataFilter(selections: IFiltersSelection): {
  [key: string]: any;
} {
  const dataFilter: { [key: string]: any } = {};
  const { fetch, ...selectionRest } = selections;
  _.forEach(selectionRest, (dataSelection: any, keyMain: string) => {
    _.forOwn(dataSelection.data, (value: any, key) => {
      if (key === 'location') {
        _.forOwn(value, (valueSub: any, keySub) => {
          if (
            valueSub !== null &&
            valueSub !== undefined &&
            valueSub?.length > 0
          ) {
            _.set(dataFilter, `${key}.${keySub}`, valueSub);
          }
        });
      } else if (value !== null && value !== undefined && value?.length !== 0) {
        if (keyMain === PropertyFilterType.Other) {
          _.set(dataFilter, `other.${key}`, value);
        } else {
          dataFilter[key] = value;
        }
      }
    });
  });
  return dataFilter;
}
